import Storage from './Storage';

/**
 * Store Categories
 * 
 */
class Categories extends Storage {
    storeName = 'categories_';
    hasOldKey = true;

    /**
     * Categories constructor
     * 
     * @param {string} id location id
     */
    constructor(id) {
        super();
        this.id = id;
        this.setKey();
    }

}

export default Categories;